const tableTitleManagementService = {
  title: 'Gestão de Serviços',
  placeholder: 'Pesquisar',
  addRowLabel: 'novo serviço',
  excelGenerateToaster: 'Exportando primeiras 2000 correspondências'
};

export default tableTitleManagementService;
